import Papa from 'papaparse';

export const exportDataToCsv = <TInput extends unknown>(data: TInput[]) => {
  const csv = Papa.unparse(data);
  return new Blob([csv], { type: 'text/csv' });
};
